import { BlankState } from '@domain-group/suit-theme'

import BlankStateImageUrl from '../../assets/no-contacts.svg'

const CampaignContactBlankList = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImageUrl}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Contacts Available</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      You don&apos;t have any contacts attached to this campaign.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      Campaign contacts can be used to share public views of important information or to use
      their details in agreements and contact.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      Contacts aren&apos;t restricted to only clients, you can store relevant contacts such as conveyancers and lawyers,
      or other relevant key businesses to find them easily later.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default CampaignContactBlankList
